import { AppBar, IconButton, makeStyles, Toolbar } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/MenuOutlined';
import clsx from 'clsx';
import logo from 'images/logo-white.svg';
import React from 'react';
import { connect } from 'react-redux';
import User from './components/User';


const mapStateToProps = ({ account, nav, auth }) => ({
    authenticated: auth.authenticated,
    user: account.item,
    navOpen: nav.openLeft,
});

const mapDispatch = (dispatch) => ({
    toggleNav: () => dispatch.nav.toggleNav(),
    logout: () => dispatch.auth.logout(),
});

const reduxConnector = connect(mapStateToProps, mapDispatch);

const propTypes = {};
const defaultProps = {};

const styles = makeStyles(({ zIndex, width, palette, ...theme }) => ({
    grow: {
        flexGrow: 1,
    },
    appBar: {
        background: palette.background.paper,
        borderBottom: `1px solid ${palette.divider}`,
        zIndex: zIndex.drawer + 1,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        width: `calc(100% - ${width.drawerLeft}px)`,
        marginLeft: width.drawerLeft,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        // color: '#FFF',
    },
    logo: {
        background: `url(${logo}) no-repeat`,
        backgroundSize: 'contain',
        width: 150,
        height: 40,
    },
}));

function Header(props) {
    const { toggleNav, user, navOpen } = props;
    // const theme = useTheme();
    // const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const classes = styles();

    return (
        <AppBar
            position="absolute"
            elevation={0}
            className={clsx(classes.appBar, {
                [classes.appBarShift]: navOpen,
            })}
        >
            <Toolbar>
                <IconButton
                    aria-label="Open drawer"
                    onClick={toggleNav}
                    className={classes.menuButton}
                >
                    <MenuIcon />
                </IconButton>

                <div className={classes.grow} />

                {user && <User user={user} />}

            </Toolbar>

        </AppBar>
    );
}

Header.propTypes = propTypes;
Header.defaultProps = defaultProps;

export default reduxConnector(Header);
